module.exports = __webpack_public_path__ + "static/media/info_7.97606525.svg";